import React from "react";
import OnlineBooking from "./components/OnlineBooking";
import Svg from "./components/svgs/svg";
import rg4js from 'raygun4js';
import { useEffect } from "react";

rg4js('apiKey', 'WTaSVCys1E9G1J1JetTctg');
rg4js('enableCrashReporting', true);

const onlineBookingPage = document.getElementById("online-booking");

const App = (props) => {
  // useEffect(() => {
  //   const unloadCallback = (event) => {
  //     event.preventDefault();
  //     event.returnValue = "";
  //     return "";
  //   };

  //   window.addEventListener("beforeunload", unloadCallback);
  //   return () => window.removeEventListener("beforeunload", unloadCallback);
  // }, []);

  return (
    <div>
      <Svg />
      {onlineBookingPage && <OnlineBooking></OnlineBooking>}
    </div>
  );
};

export default App;
